import Link from 'components/Link';
import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SubBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

// Keeps a title and its description tight (no gap between them); the block gap
// still separates the pair from the content below.
export const SubHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubTitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.3;
`;

export const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  line-height: 1.5;
`;

export const DescriptionCta = styled(Link)`
  color: ${({ theme }) => theme.colors.accent};
  font-weight: ${({ theme }) => theme.weights.bold};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const OfficeHourRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;

  ${from.mobileXL`
    grid-template-columns: 1fr 1fr 1fr;
  `}
`;

export const OfficeHourCard = styled(Link)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.grey200};
  border-radius: 8px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
`;

export const DatePill = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.basicGold};
  color: ${({ theme }) => theme.colors.judge};
  padding: 0.625rem;
`;

export const PillWeekday = styled.span`
  font-size: 0.875rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  letter-spacing: 0.07em;
  line-height: 1;
  text-transform: uppercase;
`;

export const DateTime = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 1rem 0;
`;

export const PillDate = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.3;
  text-align: center;
`;

export const TimeRange = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-size: 0.875rem;
  line-height: 1.3;
  text-align: center;
`;
